import { FormGroup } from "@material-ui/core";
import styled from "styled-components";
import { Flex } from "../../../../components/layout";


export const Details = styled(Flex)`
  justify-content: space-between;
  width: 100%;
`;

export const SwitchGroup = styled(FormGroup)`
  font-size: 0.5em;
`;